// Keep at least one complete card per status; share the remaining height by
// actual content demand, rather than reserving three equally tall empty lanes.
export const allocateStatusRows = (rows, availableHeight, gap = 6) => {
  if (!rows.length) return [];
  const minimum = rows.reduce((total, row) => total + row.minimum, 0);
  const extra = Math.max(0, availableHeight - gap * (rows.length - 1) - minimum);
  const demands = rows.map((row) => Math.max(row.minimum, row.content));
  const demand = demands.reduce((total, value) => total + value, 0);
  return rows.map((row, index) => row.minimum + (
    demand ? extra * demands[index] / demand : extra / rows.length
  ));
};
